export const baseURL  = 'https://mula.thewebtestlink.xyz/api/'
export const imageUrl = 'https://mula.thewebtestlink.xyz/'
